import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Maps.css';

const Maps = () => {
  const maps = [
    {
      name: 'Ancient Glade',
      filename: 'Ancient Glade A4.jpg',
      description: 'Map of the Ancient Glade area',
    },
    {
      name: 'Forrest',
      filename: 'Forrest A3.jpg',
      description: 'Map of the Forrest area',
    },
    {
      name: 'Village',
      filename: 'Village Entrance A3.jpg',
      description: 'Map of the Village Entrance area',
    },
  ];

  return (
    <>
      <div className="no-print">
        <Link to="/" className="back-link">
          Back to Home
        </Link>
        <h1 className="title">Maps</h1>
      </div>
      <div className="maps-container">
        {maps.map((map, index) => (
          <div key={index} className="map-card">
            <h2>{map.name}</h2>
            <div className="map-image-container">
              <img
                src={`${process.env.PUBLIC_URL}/${map.filename}`}
                alt={map.name}
                className="map-image"
              />
            </div>
            <p>{map.description}</p>
            <a
              href={`${process.env.PUBLIC_URL}/${map.filename}`}
              download={map.filename}
              className="download-button"
            >
              Download Map
            </a>
          </div>
        ))}
      </div>
    </>
  );
};

export default Maps;
